<template>
  <div class="station-cutting-log-page">
    <StationAlertMessage ref="historyAlertMessage" />
      
    <div class="station-list-container my-4">
      <div class="station-list station-search-list">
        <h2 class="text-muted">Recent cutting logs at {{productionStation.name}}</h2>

        <Spinner v-if="cuttingLogLoading" />
        <div class="row my-2" v-for="logItem of cuttingLogResults" :key="logItem.id">
          <div class="col-4"><h2>{{logItem.stock.code}} - {{logItem.stock.name}}</h2></div>
          <div class="col-3"><h2>{{logItem.glassLevel.height}} x {{logItem.glassLevel.width}}</h2></div>
          <div class="col-3"><h2>{{logItem.createdAt | formatDateTime}}</h2></div>
          <div class="col-2">
            <button class="btn btn-list-action" @click.prevent="revertCuttingLogItem(logItem)">
              <i class="far fa-undo"></i> Revert
            </button>
          </div>
        </div>
        <h2 class="text-muted text-center mt-4" v-if="cuttingLogResults.length == 0">No recent cuts made for this station</h2>
        <h2 class="text-center text-danger mt-4" v-if="cuttingLogError">{{cuttingLogError}}</h2>
      </div>
    </div>
  </div>
</template>



<style lang="scss" scoped>
.station-cutting-log-page {
  flex: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items:stretch;
  overflow-x: hidden;
}
</style>

<script>
import _ from 'lodash'
import moment from 'moment'

import formMixin from '@/mixins/form'
import Utils from '@/utils/utils'
import EventBus from '@/utils/eventBus'
import StationAlertMessage from '@/apps/glass-production-station/src/components/station/stationAlertMessage'

import { LinkTypes } from '@/store/types'

export default {
  name: 'CuttingLogPage',
  mixins: [formMixin],
  components: {
    StationAlertMessage
  },
  props: {
    productionStage: Object,
    productionStation: Object
  },
  data() {
    return {
      // Cutting Log
      cuttingLogLoading: false,
      cuttingLogError: '',
      cuttingLogResults: []
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // Page Selected - Called when this cutting log scan page is selected to be shown
    pageSelected() {
      this.$refs.historyAlertMessage.hide()

      this.requestCuttingLog()
    },
    revertCuttingLogItem(logItem) {
      this.confirmMessage('Revert Cutting?', `Are you sure you want to revert the cut for ${logItem.glassLevel.height}x${logItem.glassLevel.width} sheet of ${logItem.stock.code}-${logItem.stock.name}?`)
      .then(success => {
        if(success) {
          // Revert log item
          this.$apiService.glassProductionStationService.revertCuttingLog(this.productionStation.id, logItem.id)
          .then(response => {
            this.requestCuttingLog()
            this.$refs.historyAlertMessage.displayAlert('success', 'Cutting Log Reverted', 'Cutting log reverted and sheet placed back into inventory')
          })
          .catch(err => {
            let errorInfo = this.processFormResponse(err)
            this.$refs.historyAlertMessage.displayAlert('error', 'Revert Error!', errorInfo.errorMessage)      
          })          
        }
      })
    },

    requestCuttingLog() {
      // Last 14 days
      var startDateCreated = moment().subtract(14, 'days').toISOString()

      this.cuttingLogLoading = true
      this.cuttingLogError = ''

      // Get the cutting log
      this.$apiService.glassProductionStationService.getCuttingLog(this.productionStation.id, { startDateCreated: startDateCreated })
      .then(response => {
        this.cuttingLogResults = response.data
      })
      .catch(err => {
        this.cuttingLogError = 'Error loading cutting log'
      })
      .finally(() => {
        this.cuttingLogLoading = false
      })
    },
  }
}
</script>